const AceAccordion = require('./vendor/ace-accordion.js');
const childrenLoaded = require('@alexspirgel/children-loaded');

class Accordion extends HTMLElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		if (this.initialized) {
			return;
		}
		const acfInnerBlocksContainers = this.querySelectorAll('.block-accordion__items > .acf-innerblocks-container');
		const opened = this.getAttribute('data-open') || 0;
		for (const acfInnerBlocksContainer of acfInnerBlocksContainers) {
			acfInnerBlocksContainer.replaceWith(...acfInnerBlocksContainer.childNodes);
		}

		const aceAccordion = new AceAccordion({
			selectors: {
				accordion: '.block-accordion__items',
				item: '.block-accordion__item',
				heading: '.block-accordion__item-heading',
				content: '.block-accordion__item-content',
				content_inner: '.block-accordion__item-content-inner',
			},
		});
		if (opened && aceAccordion.accordions && aceAccordion.accordions[aceAccordion.id] && aceAccordion.accordions[aceAccordion.id].items) {
			const currentItem = aceAccordion.accordions[aceAccordion.id].items[0];
			if (currentItem) {
				currentItem.open();
			}
		}
		this.initialized = true;
	}

}

if (!customElements.get('block-accordion')) {
	customElements.define('block-accordion', Accordion, {extends: 'section'});
}
